const HEADER_FUNCTIONS = {};

HEADER_FUNCTIONS.headersWithTokenJson = token => {
    return {
        accept: 'application/json',
        'CONTENT-TYPE': 'application/json',
        Authorization: `Bearer ${token}`,
    };
};

export default HEADER_FUNCTIONS;
